import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './map.scss';

import MobileLayout from './mobile-stack';
import GoogleLocation from '../event_components/google_location';
import EventStatus from '../event_components/event_status';
import TicketPurchasing from '../event_components/ticket-purchasing';
import AddEventToCalendar from '../event_components/add_to_calendar';
import { LocaleWrapper } from '../../locale-wrapper';
import GeoMap from '../event_components/geo_map';
import CheckoutController from '../event_components/Checkout';
import { attendButtonIsVisible } from './utils';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  index: PropTypes.number,
};

function MapContainer({ event, settings }) {
  const [height, setHeight] = useState('100%');
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current.clientHeight > 0) {
      setHeight(ref.current.clientHeight);
    }
  }, [height]);
  return (
    <Col xs={6} md={6} ref={ref} style={{ minHeight: height }}>
      <GeoMap event={event} settings={settings} showGoogleMap />
    </Col>
  );
}
class DetailsContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    const { event } = this.props;

    if (event.get('type') === 'google') {
      return;
    }

    this.props.onResizeComponent();
    this.setState({
      openTicketing: !this.state.openTicketing,
    });
  };
  render() {
    const { event, settings, onResizeComponent } = this.props;
    const hasLogo = settings.get('showEventLogo');

    return (
      <Col xs={6} md={6} className={styles.details}>
        <CheckoutController
          variant="default"
          event={event}
          settings={settings}
          openTicketing={this.state.openTicketing}
          onResizeComponent={onResizeComponent}
          onClose={() => {
            this.setState({
              openTicketing: false,
            });
          }}
        >
          <>
            {hasLogo && (
              <div className={styles.header}>
                <Logo event={event} settings={settings} />
              </div>
            )}
            <div className={styles.info}>
              <Title event={event} className={styles.title} settings={settings} />
              <div className={styles.date}>
                <Time event={event} className={styles.time} settings={settings} />
              </div>

              {event.get('type') === 'google' ? (
                <GoogleLocation event={event} />
              ) : (
                <Location event={event} settings={settings} className={styles.location} />
              )}
              {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} />}
              {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
              <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />
              {attendButtonIsVisible(event, settings) && (
                <AttendButton settings={settings} event={event} className={styles.button} handleButtonClick={this.toggleAttendButton} />
              )}
              {settings.get('embedTicketPurchasing') && <TicketPurchasing settings={settings} event={event} open={this.state.openTicketing} />}
            </div>
          </>
        </CheckoutController>
      </Col>
    );
  }
}
export function MapLayout({ event, settings, index, onResizeComponent }) {
  const isEven = index % 2 === 0;
  const LeftSideComponent = isEven ? MapContainer : DetailsContainer;
  const RightSideComponent = isEven ? DetailsContainer : MapContainer;

  return (
    <Row className={cn(!settings.get('embedTicketPurchasing') ? styles.list : styles.listWithTicket, 'event', styles.map, 'map')}>
      <LeftSideComponent event={event} settings={settings} onResizeComponent={onResizeComponent} />
      <RightSideComponent event={event} settings={settings} onResizeComponent={onResizeComponent} />
    </Row>
  );
}

MapLayout.propTypes = propTypes;

export default function MapLayoutContainer({ events, settings, isMobile, onResizeComponent }) {
  const Component = isMobile ? MobileLayout : MapLayout;
  return (
    <div>
      {events.map((event, index) => (
        <LocaleWrapper event={event}>
          <Component key={event.get('id')} event={event} settings={settings} index={index} onResizeComponent={onResizeComponent} />
        </LocaleWrapper>
      ))}
    </div>
  );
}

MapLayoutContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};
